import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import clsx from 'clsx';

type Props = {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  label: string;
};

function AddItemButton({
  className, onClick, disabled, label,
}: Props) {
  const combineClassName = clsx('text-left !text-populate-green', className);
  return (
    <button
      className={combineClassName}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      <AddIcon fontSize="small" />
      {label}
    </button>
  );
}

export default AddItemButton;
